import WWPitaBreadProduct from 'models/WWPitaBreadProduct'

export const packagingInitialState = {
  category: WWPitaBreadProduct.category,
  subCategory: WWPitaBreadProduct.subCategory,
  Size: WWPitaBreadProduct.Size,
  WholeWheatCert: WWPitaBreadProduct.WholeWheatCert,
}
